<script setup>
import { ref } from 'vue';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CreditCard } from "lucide-vue-next";

const currentPlan = ref('Beta');
const nextBillingDate = ref('N/A');
</script>

<template>
  <div class="container mx-auto pt-8">
    <Card class="w-full max-w-2xl mx-auto">
      <CardHeader>
        <CardTitle class="text-2xl">Billing & Subscription</CardTitle>
        <CardDescription>
          Manage your subscription and billing information.
        </CardDescription>
      </CardHeader>
      <CardContent class="space-y-6">
        <div class="space-y-2">
          <h3 class="text-lg font-medium">Current Plan</h3>
          <p class="text-sm text-muted-foreground">{{ currentPlan }}</p>
        </div>
        
        <div class="space-y-2" v-if="nextBillingDate !== 'N/A'">
          <h3 class="text-lg font-medium">Next Billing Date</h3>
          <p class="text-sm text-muted-foreground">{{ nextBillingDate }}</p>
        </div>

        <div class="pt-4">
          <Button class="w-full" disabled>
            <CreditCard class="mr-2 h-4 w-4" />
            Upgrade Plan
          </Button>
        </div>
      </CardContent>
    </Card>
  </div>
</template> 